import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AuthConfig, NullValidationHandler, OAuthService} from 'angular-oauth2-oidc';
import {filter} from 'rxjs/operators';
import {AppConfigService} from './app-config.service';
import queryString from 'query-string';
import {parseJwt} from '../app/utilities/fn';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TranslateService} from '@ngx-translate/core';
import { LanguageService } from 'src/app/services/language.service';


@Injectable()
export class AuthConfigService {

  private _decodedAccessToken: any;
  private _decodedIDToken: any;

  get decodedAccessToken() {
    return this._decodedAccessToken;
  }

  get decodedIDToken() {
    return this._decodedIDToken;
  }

  constructor(
    private readonly oauthService: OAuthService,
    private languageService: LanguageService,
    private readonly router: Router,
    private readonly authConfig: AuthConfig,
    private readonly appconfig: AppConfigService,
    private  http: HttpClient,
    public translate: TranslateService,
  ) {
  }

  async initAuth(): Promise<any> {
    const redirectUri = `${window.location.origin}/auth-callback`;
    const logoutUrl = `${window.location.origin}/silent-refresh.html`;
    const s = await this.appconfig.loadConfig();
    return new Promise((resolveFn, rejectFn) => {
      // setup oauthService
      // delete s.apiBase;
      // delete s.apiBizzone;
      this.oauthService.configure({...s, redirectUri: redirectUri, logoutUrl: logoutUrl});
      this.oauthService.setStorage(localStorage);
      this.oauthService.tokenValidationHandler = new NullValidationHandler();

      // subscribe to token events
      this.oauthService.events
        .pipe(filter((e: any) => {
          return e.type === 'token_received';
        }))
        .subscribe(() => this.handleNewToken());
      // disabling keycloak for now
      // resolveFn();
      // continue initializing app or redirect to login-page

      this.oauthService.loadDiscoveryDocumentAndLogin().then(isLoggedIn => {
        if (isLoggedIn) {
          this.oauthService.setupAutomaticSilentRefresh();
          this.getWebMenuListByUserId();
          resolveFn(true);
        } else {
          this.oauthService.initImplicitFlow();
          rejectFn();
        }
      });

    });
  }

  private getWebMenuListByUserId () {
    const tokenData = parseJwt(this.oauthService.getAccessToken());
    const queryMeny = queryString.stringify({
      userId: tokenData.sub,
      webId: 'F64B0750-2B1D-4011-89FF-36642C1D65BE'
    });
    const options = {
      headers: new HttpHeaders({
        Authorization: this.oauthService.getAccessToken(),
        'Content-Type': 'application/json',
      })
    };
    this.http.get(`${this.appconfig.apiBase}/api/v1/webmanager/GetWebMenuListByUserId?` + queryMeny, options).subscribe((ressult: any) => {
      if (ressult.status === 'success') {
        this.languageService.setLanguage(ressult.data.acceptLanguage);
        this.translate.use(ressult.data.acceptLanguage);
        localStorage.setItem('currentLang', JSON.stringify(ressult.data));
        if (window.location.pathname.includes('/auth-callback') || window.location.pathname === '' || window.location.pathname === '/') {
          this.router.navigateByUrl('/home');
        }
      }
    });
  }

  private handleNewToken() {
    this._decodedAccessToken = this.oauthService.getAccessToken();
    this._decodedIDToken = this.oauthService.getIdToken();
  }

}
